import { observer } from "mobx-react-lite";

import {
  NodeColorSelector,
  NodeCurrentColor,
} from "@/components/doc/right-sidebar/node-viewer/NodeColorSelector";
import { setNodeColor } from "@/components/doc/right-sidebar/node-viewer/utils";
import { Sidebar } from "@/components/sidebar";
import { twMerge } from "@/utils/twMerge";

import type { ViewerNode } from "@/components/doc/right-sidebar/node-viewer/types";
import type { TailwindColor } from "@/utils/tailwindColors";

type Props = {
  node: ViewerNode;
  className?: string;
};

export const ColorSelector = observer(function ColorSelector({ node, className }: Props) {
  const handleColorChange = (color: TailwindColor) => {
    setNodeColor(node, color);
  };

  return (
    <NodeColorSelector
      color={node.color}
      triggerClassName={twMerge("flex-shrink-0", className)}
      trigger={
        <Sidebar.ToggleButton
          as="div"
          title={node.value}
          wrapperClassName="pl-[1px]"
          className="min-h-full"
        >
          <NodeCurrentColor color={node.color} />
        </Sidebar.ToggleButton>
      }
      onSelect={handleColorChange}
    />
  );
});
